// AUTO-GENERATED — Do not edit. Modify shared-config/signalr-change-feed.json instead.

export const containerToTags: Readonly<Record<string, readonly string[]>> = {
  "Dashboards": ["Dashboards", "WidgetData"],
  "DashboardDataModels": ["DashboardModel"],
  "DataMappingConfigurations": ["MappingConfiguration"],
  "AgentOperations": ["AgentOperation"],
  "AgentDataV2": ["AgentData"],
  "ConnectorSchemas": ["ConnectorSyncData"],
  "IngestionHistory": ["ConnectorSyncData"],
  "DataPipelineConfigurations": ["DataPipelineConfiguration", "OpsAppObjectDefinitions"],
  "TeamSyncStatus": ["GoldPipelineStatus", "ValidationRun", "WidgetData", "DashboardRecords"],
  "SharedReports": ["SharedReports", "SharingOverview"],
  "ExternalServiceCredentials": ["ConnectorStatus"],
  "OpsAppObjects": ["OpsAppObjects"],
  "TeamsV2": ["ActiveTeam", "CoreApplicationContext", "GitHubAppStatus"],
};

export const allWatchedTags: readonly string[] = [
  ...new Set(Object.values(containerToTags).flat())
];
